export default __webpack_public_path__ + "static/media/Foto-12.8ac1f215.png";